import { apiClient, type ApiResponse } from '@/lib/apiClient';
import type { QueryOptions } from '@/lib/reactQuery';
import { useQuery } from '@tanstack/react-query';

interface Username {
  center: {
    name: string;
  };
  username: string;
}

type GetForgottenUsernameListResponse = ApiResponse<{ usernames: Username[] }>;

export const getForgottenUsernameList = async ({ token }: { token: string }) => {
  const response = await apiClient.get<GetForgottenUsernameListResponse>(`/v1/auth/forgotten-username/${token}`);
  return response.data;
};

interface UseGetForgottenUsernameListOptions {
  token: string;
  options?: QueryOptions<GetForgottenUsernameListResponse>;
}

export const useGetForgottenUsernameList = ({ token, options }: UseGetForgottenUsernameListOptions) => {
  return useQuery({
    queryKey: ['getForgottenUsernameList', token],
    queryFn: () => getForgottenUsernameList({ token }),
    ...options,
  });
};
